/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_BlockedInputs */

const en_landing_studio_blocked = /** @type {(inputs: Landing_Studio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This prompt isn't allowed. Please keep it safe for work.`)
};

const zh_landing_studio_blocked = /** @type {(inputs: Landing_Studio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该提示词不被允许，请保持内容健康。`)
};

/**
* | output |
* | --- |
* | "This prompt isn't allowed. Please keep it safe for work." |
*
* @param {Landing_Studio_BlockedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_blocked = /** @type {((inputs?: Landing_Studio_BlockedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_BlockedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_blocked(inputs)
	return zh_landing_studio_blocked(inputs)
});
export { landing_studio_blocked as "landing.studio.blocked" }